module.exports = __webpack_public_path__ + "static/media/ads.47d71e32.jpg";